// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TMyo","icon":"styles_icon__GDzj3"};